interface SVGProps {
  color: string;
  style: React.CSSProperties;
}

const SVG = ({ color, style }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="50"
    viewBox="0 0 48 50"
    fill="none"
  >
    <g clipPath="url(#clip0_487_11698)">
      <path
        d="M44.2761 33.4157V33.3964"
        stroke={color}
        strokeWidth="1.59292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.783 23.6953C22.8326 22.0118 29.9033 13.2997 29.9033 2.92507C29.9033 0.336688 35.017 -0.0210564 36.3638 4.77692C37.8789 10.1852 35.4378 14.92 33.586 19.5286H42.8032"
        stroke={color}
        strokeWidth="1.59292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.8239 19.5286C44.8651 19.5286 46.5065 21.1911 46.5065 23.2113C46.5065 25.2525 44.8441 26.8939 42.8239 26.8939H41.8979"
        stroke={color}
        strokeWidth="1.59292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.8979 26.9149C43.9391 26.9149 45.5805 28.5774 45.5805 30.5976C45.5805 32.6388 43.9181 34.2803 41.8979 34.2803H40.9719"
        stroke={color}
        strokeWidth="1.59292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.0463 34.2803C42.0875 34.2803 43.7289 35.9428 43.7289 37.963C43.7289 40.0042 42.0665 41.6456 40.0463 41.6456H39.1204"
        stroke={color}
        strokeWidth="1.59292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.898 26.9149C43.9392 26.9149 45.5807 28.5774 45.5807 30.5976C45.5807 32.6388 43.9182 34.2803 41.898 34.2803H40.0461"
        stroke={color}
        strokeWidth="1.59292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.1205 48.1271H26.2207C22.517 48.1271 15.783 44.739 15.783 44.739"
        stroke={color}
        strokeWidth="1.59292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.1945 41.6666H38.6574C40.4462 41.6666 41.8771 43.1187 41.8771 44.8863C41.8771 46.6751 40.4251 48.106 38.6574 48.106H37.2686"
        stroke={color}
        strokeWidth="1.59292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4479 45.3703C11.9593 45.3703 12.3738 44.9558 12.3738 44.4444C12.3738 43.933 11.9593 43.5185 11.4479 43.5185C10.9365 43.5185 10.522 43.933 10.522 44.4444C10.522 44.9558 10.9365 45.3703 11.4479 45.3703Z"
        stroke={color}
        strokeWidth="1.59292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6785 19.4865H3.15662C1.99441 19.4865 1.05225 20.4287 1.05225 21.5909V46.8434C1.05225 48.0056 1.99441 48.9478 3.15662 48.9478H13.6785C14.8407 48.9478 15.7829 48.0056 15.7829 46.8434V21.5909C15.7829 20.4287 14.8407 19.4865 13.6785 19.4865Z"
        stroke={color}
        strokeWidth="1.59292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_487_11698">
        <rect width="47.5589" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
